import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { constantsRegistry } from '../constants/tableConstantsFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import applyReducer, { reduceReducers, setEntities } from './applyReducer';
import { makeAssetTree } from '../components/assets/assetSelectors';
const entityReducer = entityReducerFactory('assetFilterReport');
const assetFilterReportConstants = constantsRegistry('assetFilterReport');
const defaultIndexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
  paging: null
});
const initState = _objectSpread(_objectSpread({}, entityReducer.initState), {}, {
  indexQuery: defaultIndexQuery,
  initialIndexQuery: defaultIndexQuery
});

// REDUCERS
const hierarchicalDataReducer = (state, action) => _objectSpread(_objectSpread({}, state), setEntities(state, makeAssetTree(action.data)));
const reducers = _objectSpread(_objectSpread({}, entityReducer.reducers), {}, {
  [assetFilterReportConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[assetFilterReportConstants.INDEX_SUCCESS], hierarchicalDataReducer)
});
export default applyReducer(reducers, initState);